export default __webpack_public_path__ + "static/media/coreIcon.60e21821.png";